import { Column, Row } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { EndTimeInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/TextInput/TimeInput/EndTimeInput';
import { StartTimeInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/TextInput/TimeInput/StartTimeInput';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { StartTimeMeridianSelect } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/MeridianSelect/StartTimeMeridianSelect';
import { EndTimeMeridianSelect } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/MeridianSelect/EndTimeMeridianSelect';

export function TimeSelection(): JSX.Element {
  const {
    formValues: { isTimeInputDisabled },
  } = useMealCreditFormData();

  return (
    <Row gutter={12}>
      <Column phone={6} gutter={12}>
        <Row gutter={8}>
          <Column phone={7} gutter={8}>
            <StartTimeInput
              name="startTime"
              id="startTime"
              disabled={isTimeInputDisabled}
            />
          </Column>
          <Column phone={5} gutter={8}>
            <StartTimeMeridianSelect
              name="startTimeMeridian"
              id="startTimeMeridian"
              disabled={isTimeInputDisabled}
            />
          </Column>
        </Row>
      </Column>
      <Column phone={6} gutter={12}>
        <Row gutter={8}>
          <Column phone={7} gutter={8}>
            <EndTimeInput
              name="endTime"
              id="endTime"
              disabled={isTimeInputDisabled}
            />
          </Column>
          <Column phone={5} gutter={8}>
            <EndTimeMeridianSelect
              name="endTimeMeridian"
              id="endTimeMeridian"
              disabled={isTimeInputDisabled}
            />
          </Column>
        </Row>
      </Column>
    </Row>
  );
}
